import when from 'when';
import request from 'reqwest';
import RegistrationConstants from '../constants/RegistrationConstants';
import constants from "../constants/BaseConstants";
import AuthService from "./AuthService";

class RegistrationService {

  sendData(data) {
    let newData = Object.assign({}, data);
    let types = '';
    newData.password = 'password';
    newData.types.forEach((item) => {
      types += item.value + ',';
    });
    newData.phone_number = newData.phone_number.replace(/ |\(|\)|-|/g, '');
    newData.types = types.substring(0, types.length - 1);
    return when(request({
      url: RegistrationConstants.REG_SIGNUP_AS_MERCHANT,
      method: 'POST',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      data: JSON.stringify({
        merchant: newData
      })
    }));
  }

  verifyEmail(token) {
    return when(request({
      url: RegistrationConstants.REG_VERIFY_EMAIL_TOKEN + token,
      method: 'GET',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json'
    }));
  }

  sendOwnerData(data) {
    return when(request({
      url: RegistrationConstants.REG_OWNER_URL,
      method: 'POST',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      data: JSON.stringify({
        merchant: {
          owner_first_name: data.first_name,
          owner_last_name: data.last_name,
          password: data.password
        },
        confirm_email_token: data.confirm_email_token
      })
    }));
  }


  sendCall(extension, token) {
    return when(request({
      url: RegistrationConstants.REG_CALL_TO_VERIFY,
      method: 'POST',
      headers: {
        'Authorization': 'Token token=' + token
      },
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      data: JSON.stringify({extension: extension})
    }));
  }


  sendCode(token) {
    return when(request({
      url: RegistrationConstants.REG_SEND_VERIFICATION,
      method: 'POST',
      headers: {
        'Authorization': 'Token token=' + token
      },
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json'
    }));
  }

  checkCode(code, token) {
    return when(request({
      url: RegistrationConstants.REG_VERIFY_PHONE_NUMBER,
      method: 'POST',
      headers: {
        'Authorization': 'Token token=' + token
      },
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json',
      data: JSON.stringify({
        code: code
      })
    }));
  }

  getTypes() {
    return when(request({
      url: constants.BASE_URL + 'merchants/signup/merchant_types',
      method: 'GET',
      crossOrigin: true,
      contentType: 'application/json',
      withCredentials: true,
      type: 'json'
    }));
  }

}

export default new RegistrationService()



/** WEBPACK FOOTER **
 ** ./src/services/RegistrationService.js
 **/